/**
 * @name ID
 * @constant
 * @string
 * @description ID used to identify this modal
 */
export const ID = 'CREATE_CONNECTION'